/**
 * Abstract Hypercube.js system.
 * @example
 * class SystemExample extends System {
 *
 *     tick($timeframe) {}
 * }
 */
class System {

    /**
     * Stores the Hypercube.js Game Engine running the system.
     * @type {import('../../index.js').Engine}
     * @protected
     */
    $engine;

    /**
     * Gets the Hypercube.js Game Engine running the system.
     * @type {import('../../index.js').Engine}
     * @public
     * @readonly
     */
    get engine() {

        return this.$engine;
    }

    /**
     * Gets the scene running.
     * @type {import('../../index.js').Scene}
     * @public
     * @readonly
     */
    get scene() {

        return this.$engine.scene;
    }

    /**
     * Destroys the system.
     * @public
     */
    destroy() {}

    /**
     * Resizes the system.
     * @public
     */
    resize() {}

    /**
     * Sets the Hypercube.js Game Engine running the system.
     * @param {import('../../index.js').Engine} $engine The Hypercube.js Game Engine to set.
     * @public
     */
    setengine($engine) {

        this.$engine = $engine;
    }

    /**
     * Starts the system.
     * @public
     */
    start() {}

    /**
     * Updates the system once.
     * @param {number} $timeframe The timeframe duration (in ms).
     * @public
     */
    tick($timeframe) {}
}

export {

    System
};

export default System;
